import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import style from "css/realtime.module.css";
import { Modal, Tabs, Table, Space, Input, Button, Select, Empty } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { closeAlert, openAlert } from "redux/slices/alertSlice";
import { useTranslation } from "react-i18next";

function AddEndpointModal(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [registEndpointOption, setRegistEndpointOption] = useState([]);
  const [registEndpoints, setRegistEndpoins] = useState([]);
  const [unregistEndpoints, setUnregistEndpoins] = useState([]);

  const [unregistEndpoint, setUnregistEndpoint] = useState({
    ENDPOINT_NM: "",
    ENDPOINT_IP: "",
  });

  const regist_columns = [
    {
      title: "",
      dataIndex: "REMOVE",
      key: "REMOVE",
      align: "center",
      width: "15%",
      render: (_, el) => (
        <>
          <CloseCircleOutlined
            style={{ fontSize: "18px" }}
            onClick={() =>
              setRegistEndpoins(
                registEndpoints.filter((endpoint) => endpoint.key !== el.key)
              )
            }
          />
        </>
      ),
    },
    {
      title: t("LIST.DEVICE_NAME"),
      key: "ENDPOINT_NM",
      dataIndex: "ENDPOINT_NM",
      width: "40%",
    },
    {
      title: t("LIST.DEVICE_IP"),
      key: "ENDPOINT_IP",
      dataIndex: "ENDPOINT_IP",
      width: "45%",
    },
  ];

  const unregist_columns = [
    {
      title: "",
      dataIndex: "REMOVE",
      key: "REMOVE",
      align: "center",
      width: "15%",
      render: (_, el) => (
        <>
          <CloseCircleOutlined
            style={{ fontSize: "18px" }}
            onClick={() =>
              setUnregistEndpoins(
                unregistEndpoints.filter((endpoint) => endpoint.key !== el.key)
              )
            }
          />
        </>
      ),
    },
    {
      title: t("LIST.DEVICE_NAME"),
      key: "ENDPOINT_NM",
      dataIndex: "ENDPOINT_NM",
      width: "40%",
    },
    {
      title: t("LIST.DEVICE_IP"),
      key: "ENDPOINT_IP",
      dataIndex: "ENDPOINT_IP",
      width: "45%",
    },
  ];

  let items = [
    {
      key: "REGIST_ENDPOINT_TAB",
      label: t("LABEL.REGISTERED_DEVICE"),
      children: (
        <div className={style.regist_endpoint}>
          <Select
            showSearch
            size="large"
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            // onInputKeyDown={(input, option) => {
            //   console.log(input, option);
            //   if (input.key === "Enter") {
            //     console.log(input.currentTarget.value);
            //     console.log(
            //       (option?.label ?? "").includes(input.currentTarget.value)
            //     );
            //     // if((option?.label ?? "").includes(e.currentTarget.value))
            //   }
            // }}
            onSelect={(value, option) => {
              if (
                registEndpoints.find(
                  (endpoint) => endpoint.ENDPOINT_ID === option.ENDPOINT_ID
                )
              ) {
                const obj = {
                  title: t("MESSAGE.NOTIFICATION"),
                  content: t("MESSAGE.ALREADY_ADDED_DEVICE"),
                  submitEventHandler: () => {
                    dispatch(closeAlert());
                  },
                };
                dispatch(openAlert(obj));
                return;
              }
              setRegistEndpoins([...registEndpoints, option]);
            }}
            options={registEndpointOption}
          />

          <Table
            rowKey="uid"
            className={style.registEndpoint_table}
            columns={regist_columns}
            pagination={false}
            style={{
              height: "200px",
            }}
            scroll={{
              y: 140,
            }}
            dataSource={registEndpoints}
            locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
          />
        </div>
      ),
    },
    {
      key: "UNREGIST_ENDPOINT_TAB",
      label: t("LABEL.UNREGISTERED_DEVICE"),
      children: (
        <div className={style.unregist_endpoint}>
          <Space.Compact size="large">
            <Input
              placeholder={t("LIST.DEVICE_NAME")}
              style={{ width: "40%" }}
              value={unregistEndpoint.ENDPOINT_NM}
              onChange={(e) =>
                setUnregistEndpoint({
                  ...unregistEndpoint,
                  ENDPOINT_NM: e.currentTarget.value,
                })
              }
            />
            <Input
              placeholder={t("LIST.DEVICE_IP")}
              style={{ width: "60%" }}
              value={unregistEndpoint.ENDPOINT_IP}
              onChange={(e) =>
                setUnregistEndpoint({
                  ...unregistEndpoint,
                  key: e.currentTarget.value,
                  ENDPOINT_IP: e.currentTarget.value,
                })
              }
            />
            <Button
              type="primary"
              disabled={
                unregistEndpoint.ENDPOINT_NM === "" ||
                  unregistEndpoint.ENDPOINT_IP === ""
                  ? true
                  : false
              }
              onClick={() => {
                if (
                  unregistEndpoints.find(
                    (endpoint) =>
                      endpoint.ENDPOINT_IP === unregistEndpoint.ENDPOINT_IP
                  )
                ) {
                  const obj = {
                    title: t("MESSAGE.NOTIFICATION"),
                    content: t("MESSAGE.ALREADY_ADDED_DEVICE"),
                    submitEventHandler: () => {
                      dispatch(closeAlert());
                    },
                  };
                  dispatch(openAlert(obj));
                  return;
                }
                setUnregistEndpoins([...unregistEndpoints, unregistEndpoint]);
                setUnregistEndpoint({});
              }}
            >
              {t("BTN.ADD")}
            </Button>
          </Space.Compact>

          <Table
            rowKey="uid"
            className={style.unregistEndpoint_table}
            columns={unregist_columns}
            pagination={false}
            style={{
              height: "200px",
            }}
            scroll={{
              y: 140,
            }}
            dataSource={unregistEndpoints}
            locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
          />
        </div>
      ),
    },
  ];

  const getEndpoint = useCallback(() => {
    let url = "/schedule/vc_endpoint";

    axios.get(url).then((res) => {
      if (res.status === 200) {
        let endpoints = [];
        endpoints = res.data.ENDPOINT.map((data) => {
          return {
            ...data,
            key: data.ENDPOINT_ID,
            label: data.ENDPOINT_NM,
            value: data.ENDPOINT_IP,
          };
        });
        setRegistEndpointOption(endpoints);
      }
    });
  }, []);

  useEffect(() => {
    getEndpoint();
  }, [getEndpoint]);

  return (
    <Modal
      centered
      title={t("BTN.ADD_DEVICE")}
      open={props.open}
      onCancel={props.close}
      okText={t("BTN.ADD")}
      cancelText={t("BTN.CANCEL")}
    >
      <Tabs
        centered
        defaultActiveKey="REGIST_ENDPOINT_TAB"
        size="large"
        items={items}
      />
    </Modal>
  );
}

export default AddEndpointModal;
